<template>
  <div class="panel">
    <div class="panel-heading">
      <div class="panel-label">
        <h3>Shop cubes customization</h3>
        <input type="checkbox" v-if="!displayEnvs && user.role === 'admin'" v-model="displayFlat">
      </div>
    </div>
    <div class="panel-body">
      <setup-manager :data.sync="setupData" :edit-mode="editMode" :helper="helper" />
      <!-- JESLI ENV TO ENV -->
      <!-- JAK GRUPA (SERVICE TO PANEL) -->
      <div v-if="!displayFlat">
        <div v-for="(service, serviceIndex) in toDisplay" :key="serviceIndex">
          <div v-if="service.envs.length > 0">
            <div class="alert alert-secondary service">
              <div class="alert-text">
                {{service.serviceParagraph}} {{service.serviceParagraph.includes('Service') ? null : "Service"}}
              </div>
              <i class="up" v-if="service.open"></i>
              <i class="down" v-else></i>
            </div>
            <div>
              <env-input
                class="row form-group enviroment"
                v-for="(env, envIndex) in service.envs"
                :key="envIndex"
                v-if="env.show || !displayFlat || user.role === 'admin'"
                :env="service.envs[envIndex]"
                @envChange="change"
              >
              </env-input>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-for="(service, serviceIndex) in toDisplay" :key="serviceIndex">
          <div v-if="service.envs.length > 0">
            <env-input
              class="row form-group enviroment"
              v-for="(env, envIndex) in service.envs"
              :key="envIndex"
              v-if="env.show"
              :env="service.envs[envIndex]"
              @envChange="change"
            >
            </env-input>
          </div>
        </div>
      </div>
    </div>
</div>
</template>
<script type="text/babel">
import { mapGetters, mapMutations, mapActions } from "vuex";

import { required } from "vuelidate/lib/validators";
import _ from 'underscore';

import EnvInput from "./Envs/Input.vue";
import SetupManager from './SetupManager';
export default {
  name: "envs",
  data() {
    return {
      displayFlat: false,
      toDisplay: [],
      opened: {}
    };
  },
  props: {
    envConfigs: {},
    displayEnvs: false,
    data: {
      type: Object,
      default(){
          return {
              colors: {'primary':'#ffffff'}
          };
      }
    },
    editMode: {
      type: Boolean,
      default: false
    },
    helper: {
      type: Boolean,
      default:false
    }
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      defaultJson: "getEnvMenu",
      envs: "currentEnvs",
      getCurrentShopEnabledProperty: "getCurrentShopEnabledProperty"
    }),
    setupData: {
      get() {
        return this.data;
      },
      set(newValue) {
        this.$emit("update:data", newValue);
      }
    }
  },
  components: {
    EnvInput,
    SetupManager
  },
  created() {
    if(this.user.role !== 'admin'){
      this.displayFlat = 'true';
    }
  },
  watch: {
    envConfigs(newVal, prevVal) {
        this.toDisplay = newVal;
    },
    getCurrentShopEnabledProperty(newVal, oldVal) {
      //TO pewnie nie dziala LOL
      this.setEnvByKeyName("show_app_info", newVal);
    },
    /*setupData: {
      handler: function(newVal, oldVal) {
        //TO MAGNIA Z BARCODEM
        if(this.setCurrentShopFormIsValidSetupManager){
          this.setCurrentShopFormIsValidSetupManager(!this.$v.setupData.$invalid);
          if(this.envConfigs && this.envConfigs.renderdevice &&  this.envConfigs.renderdevice.barcode_product) {
            this.envChange('barcode_product', this.envConfigs.renderdevice.barcode_product);
          }
        }
      },
      dee: true
    }*/
  },
  methods: {
    setDefaultConfig(language) {
      const config = this.defaultJson[language];
      config.forEach(({ key, value }) => this.setEnvByKeyName(key, value));
    },
    setEnvByKeyName(envKey, envValue) {
      this.toDisplay.forEach(({ serviceName, envs }, serviceIndex) => {
        envs.forEach(({ key, value }, envIndex) => {
          if (envKey === key) {
            this.toDisplay[serviceIndex].envs[envIndex].value = envValue;
            if(key !== "default_language")
              this.change(envKey, envValue)
          }
        });
      });
    },
    change(key, value) {
      if (key === "default_language") {
        this.setDefaultConfig(value);
      }

      if(key === "barcode_product") {
        this.$emit('bardcode', value);
      }

      if(key === "currency") {
        this.$emit('currency', value);
      }

      if(key === "receipt_show_barcode") {
        this.$emit('showBarcode', value);
      }

      if(key === "proxy") {
        this.$emit('proxy', value);
      }
      if(key === "testregistry") {
        this.$emit('testregistry', value === "true" ? true : false);
      }

      if(key === "printcube_brand") {
        this.$emit('printcubeBrand', value);
      }

      /*let envConfigs = this.mapFormData(this.json);
      this.setupData.envConfigs = envConfigs;
      this.$emit("envChange");*/
    }
  },
  beforeMount() {
    this.setupData = this.data;
  },
  validations: {
    setupData: {
      wifi: {
        required
      },
      envConfigs: {}
    }
  }
};
</script>

<style lang="scss" scoped>
.enviroment {
  display: flex;
  align-items: center;
}

.color {
  width: 32px;
  border-left: 1px solid black;
}
.service {
  padding: 10px;
  padding-left: 40px;
  margin: 0 0 5px 0;
  cursor: pointer;
  i {
    border: solid black;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 5px;
    position: absolute;
    left: 14px;
  }
  .down {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }
  .up {
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
  }
}
input::-webkit-input-placeholder,
.selectPlaceholder {
  color: lightgray;
}
</style>
